import { createBrowserHistory } from 'history';

const createHistory = () =>
  createBrowserHistory({ basename: `${process.env.PUBLIC_URL}` });

export default createHistory;
